import { render } from "./LogComponent.vue?vue&type=template&id=11f5cfd8&scoped=true"
import script from "./LogComponent.vue?vue&type=script&lang=js"
export * from "./LogComponent.vue?vue&type=script&lang=js"

import "./LogComponent.vue?vue&type=style&index=0&id=11f5cfd8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f5cfd8"]])

export default __exports__